import React from "react";

const FibreconnectResult = (props) => {
    const details = props.data?.FibreConnect?.details;

    if (!details) {
        return (
            <div style={{ padding: '16px', color: '#64748b', fontStyle: 'italic', textAlign: 'center' }}>
                Nessun dettaglio disponibile per FibreConnect.
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <div className="statGrid">
                <div className="statCard">
                    <span className="statLabel">Area Industriale</span>
                    <span className="statValue" style={{ color: '#0284c7' }}>{details.Area_Industriale || 'N/D'}</span>
                </div>
                <div className="statCard">
                    <span className="statLabel">Comune / Città</span>
                    <span className="statValue">{details.Citta || 'N/D'}</span>
                </div>
                <div className="statCard">
                    <span className="statLabel">Indirizzo</span>
                    <span className="statValue">{details.Indirizzo || 'N/D'} {details.Numero_Civico || ''}</span>
                </div>
                {details.plusCODE && (
                    <div className="statCard">
                        <span className="statLabel">PlusCode OLC</span>
                        <span className="statValue" style={{ color: '#7e22ce', fontSize: '0.95rem' }}>{details.plusCODE}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FibreconnectResult;

